import React from 'react';
import {
	Layer,
	LayerProps,
	Source,
	SourceProps,
} from 'react-map-gl';

type GeoJsonLayerProps = {
	id: string;
	data: SourceProps['data'] | object | null;
	type: LayerProps['type'];
	layerStyle?: Partial<LayerProps>;
	lineMetrics?: boolean;
};

const GeoJsonLayer = ({
	id,
	data,
	type,
	layerStyle = {},
	lineMetrics = false,
}: GeoJsonLayerProps) => (
	<Source
		id={id}
		type="geojson"
		data={(data ?? undefined) as SourceProps['data']}
		lineMetrics={lineMetrics}
	>
		<Layer
			{...layerStyle}
			id={layerStyle.id ?? `${id}-layer`}
			type={layerStyle.type ?? type}
			paint={layerStyle.paint ?? {}}
		/>
	</Source>
);

export default GeoJsonLayer;
